module.exports = __webpack_public_path__ + "static/img/3areaB_22.27b791d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_22.png
// module id = 1174
// module chunks = 1